import { createConfig, fallback, http } from "wagmi";
import { injected, walletConnect } from "wagmi/connectors";

import { arbitrum, arbitrumSepolia, base, baseSepolia, bsc, bscTestnet, realTestnet, supportedChains } from "./chain";

const projectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
const alchemyKey = import.meta.env.VITE_ALCHEMY_API_KEY;

export const wagmiConfig = createConfig({
	chains: supportedChains,
	connectors: [
		injected(),
		...(projectId
			? [
					walletConnect({
						projectId,
						metadata: {
							name: "Real Estate Tokenization",
							description: "Real Estate Tokenization Marketplace",
							url: typeof window !== "undefined" ? window.location.origin : "",
							icons: []
						}
					})
				]
			: [])
	],
	transports: {
		[realTestnet.id]: http(import.meta.env.VITE_REAL_TESTNET_RPC || "https://explorer.reallayer.com/api/eth-rpc"),
		[bscTestnet.id]: fallback([
			...(alchemyKey ? [http(`https://bnb-testnet.g.alchemy.com/v2/${alchemyKey}`)] : []),
			http("https://data-seed-prebsc-1-s1.bnbchain.org:8545"),
			http("https://data-seed-prebsc-2-s1.bnbchain.org:8545"),
			http("https://data-seed-prebsc-1-s2.bnbchain.org:8545")
		]),
		[baseSepolia.id]: fallback([
			...(alchemyKey ? [http(`https://base-sepolia.g.alchemy.com/v2/${alchemyKey}`)] : []),
			http("https://sepolia.base.org")
		]),
		[arbitrumSepolia.id]: fallback([
			...(alchemyKey ? [http(`https://arb-sepolia.g.alchemy.com/v2/${alchemyKey}`)] : []),
			http("https://sepolia-rollup.arbitrum.io/rpc")
		]),
		[arbitrum.id]: fallback([
			...(alchemyKey ? [http(`https://arb-mainnet.g.alchemy.com/v2/${alchemyKey}`)] : []),
			http("https://arb1.arbitrum.io/rpc")
		]),
		[base.id]: fallback([
			...(alchemyKey ? [http(`https://base-mainnet.g.alchemy.com/v2/${alchemyKey}`)] : []),
			http("https://mainnet.base.org")
		]),
		[bsc.id]: fallback([
			...(alchemyKey ? [http(`https://bnb-mainnet.g.alchemy.com/v2/${alchemyKey}`)] : []),
			http("https://bsc-dataseed1.binance.org")
		])
	}
});

declare module "wagmi" {
	interface Register {
		config: typeof wagmiConfig;
	}
}
